import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function noDuplicateItemInList<T = any>(
  listAName: string,
  listBName: string,
  checkIsDuplicate: (itemA: T, itemB: T) => boolean,
  errorMsg: ValidationErrors
): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const listA = group.get(listAName)?.value || ([] as T[]);
    const listB = group.get(listBName)?.value || ([] as T[]);
    let hasDuplicate = false;

    for (const itemA of listA) {
      for (const itemB of listB) {
        if (checkIsDuplicate(itemA, itemB)) {
          hasDuplicate = true;
          break;
        }
      }
    }

    return hasDuplicate ? errorMsg : null;
  };
}
